// extracted by mini-css-extract-plugin
export default {"typeSection":"GraphicsTypeSection_typeSection__VW+FB","label":"GraphicsTypeSection_label__do0Rf"};